import FeedNotice from './FeedNotice';
import FeedNoticeContainer from './FeedNotice.container';

export default FeedNoticeContainer(FeedNotice);
